<template>
  <div class="individual-record-load-error">
    <div class="text-neutral-text-strong text-lg text-center mb-8">
      <FontAwesomeIcon :icon="['fak', 'warning']" />
      We encountered an error.
    </div>
    <div class="text-sm text-neutral-text-weak text-center pb-24">
      <p>We hit a snag loading this record. Please try again.</p>
      <p>
        If this problem persists, please contact
        <a target="_blank" href="mailto:support@crossbeam.com"
          >support@crossbeam.com</a
        ><template v-if="isIntercomEnabled">
          or
          <BittsLink
            url="#"
            text="chat with our support team"
            @click="showIntercom" /></template
        >.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsLink } from '@crossbeam/bitts';

import useIntercom from '@/composables/useIntercom';

const { isIntercomEnabled, showIntercom } = useIntercom();
</script>
